/// AXIOS ///
import axios from "axios";
import { AxiosError } from "axios";
/// REDUX ///
import { Dispatch } from "redux";
import { RootState } from "api/reducers";
/// ACTIONS ///
import { Action } from "api/action_types/price_lists";
import { Action as AuthAction } from "api/action_types/authentication";
/// ACTION TYPES 
import { ActionType } from "api/action_types/price_lists";
import { ActionType as AuthActionType } from "api/action_types/authentication";
/// URLS ///
import { url_prefix } from "settings";
import { shop_price_control_url } from "../endpoint";

export const getPriceControls = () => {
  return async (dispatch: Dispatch<Action | AuthAction>, getState: () => RootState) => {
    const { user } = getState().authentication;

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${user?.token}`
      }
    }

    const url = `${url_prefix}${shop_price_control_url}/0/?user_id=${user?.id}&`;

    try {
      const { data: price_controls } = await axios.get(url, config);

      dispatch({
        type: ActionType.GET_PRICE_CONTROLS,
        price_controls
      });
    }
    catch (err) {
      if (err instanceof AxiosError) {
        dispatch({
          type: ActionType.PRICE_LIST_ERROR,
          payload: err.message
        });
        if (err && err.response && err.response.status === 401) {
          dispatch({
            type: AuthActionType.AUTH_FAILED
          });
        }
      }
    }
  }
}
